import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderMenuItem } from './header-menu';

@Component({
  selector: 'lib-header-desktop-nav',
  imports: [RouterModule, MatButtonModule, TranslateModule],
  templateUrl: './header-desktop-nav.component.html',
  styleUrl: './header-desktop-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: contents' },
})
export class HeaderDesktopNavComponent {
  readonly menu = input.required<HeaderMenuItem[]>();
}
